const STORAGE_KEY = 'authEscalationSuppression';

let suppressedUntil = 0;
let suppressionReason = null;
let stateLoaded = false;

function readStoredState() {
    if (typeof window === 'undefined' || !window.sessionStorage) {
        return;
    }
    try {
        const raw = window.sessionStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return;
        }
        const parsed = JSON.parse(raw);
        const nextUntil = Number(parsed?.until);
        if (!Number.isFinite(nextUntil) || nextUntil <= Date.now()) {
            window.sessionStorage.removeItem(STORAGE_KEY);
            return;
        }
        suppressedUntil = nextUntil;
        suppressionReason = typeof parsed?.reason === 'string' ? parsed.reason : null;
    } catch {
        try {
            window.sessionStorage.removeItem(STORAGE_KEY);
        } catch {}
    }
}

function ensureStateLoaded() {
    if (stateLoaded) {
        return;
    }
    stateLoaded = true;
    readStoredState();
}

function persistState() {
    if (typeof window === 'undefined' || !window.sessionStorage) {
        return;
    }
    try {
        if (suppressedUntil > Date.now()) {
            window.sessionStorage.setItem(
                STORAGE_KEY,
                JSON.stringify({
                    until: suppressedUntil,
                    reason: suppressionReason,
                })
            );
        } else {
            window.sessionStorage.removeItem(STORAGE_KEY);
        }
    } catch {}
}

export function suppressAuthEscalationFor(durationMs, reason = null) {
    ensureStateLoaded();
    const safeDurationMs = Number.isFinite(durationMs) ? Math.max(0, durationMs) : 0;
    const nextUntil = Date.now() + safeDurationMs;
    if (nextUntil >= suppressedUntil) {
        suppressedUntil = nextUntil;
        suppressionReason = reason || null;
        persistState();
    }
    return suppressedUntil;
}

export function isAuthEscalationSuppressed() {
    ensureStateLoaded();
    if (suppressedUntil <= Date.now()) {
        suppressedUntil = 0;
        suppressionReason = null;
        persistState();
        return false;
    }
    return true;
}

export function getAuthEscalationSuppressionReason() {
    return isAuthEscalationSuppressed() ? suppressionReason : null;
}

export function getAuthEscalationSuppressionRemainingMs() {
    if (!isAuthEscalationSuppressed()) {
        return 0;
    }
    return Math.max(0, suppressedUntil - Date.now());
}

export function clearAuthEscalationSuppression() {
    ensureStateLoaded();
    suppressedUntil = 0;
    suppressionReason = null;
    persistState();
}
